/* eslint-disable no-throw-literal,no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import { setData } from 'lib/sequence/model/api/set'
import { showBlockingDialog } from 'app/_shared/events/dialog'
import action from 'app/_shared/events/action'
import submitWithDrafts from 'app/_shared/hook/model/submitWithDrafts'
import { requestOptionPassword } from 'app/optionManagement/action/generate'

/**
 * Displays an error dialog intended to inform the user about why a password cannot be generated.
 *
 * @param module  current module
 * @param info    translation object containing `messageKey` and `message`
 */
const showErrorDialog = async (
  module: Gaia.AppModule.Spec,
  info: any,
) => await showBlockingDialog(module, null, {
  title: {
    ns: 'optionManagement',
    key: 'label.passwordNotGenerated',
    defaultValue: 'Password could not be generated',
  },
  text: {
    ns: 'optionManagement',
    key: info.messageKey,
    defaultValue: info.message,
    md: true,
  },
  ok: {
    ns: 'common',
    key: 'button.ok',
    defaultValue: 'Ok',
  },
  cancel: false,
})

/**
 * Attempts to obtain the password of the current OptionManagement model.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const getPassword = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const model = module[G.MODEL]

  try {
    const result = await requestOptionPassword(module)
    const { response, password } = result
    setData(model, { response, password }, { updateCache: true })
  } catch (e: any) {
    setData(model, { response: e }, { updateCache: true })
    console.error('Unable to generate OptionManagement password:', e.message)
    await showErrorDialog(module, e)
  } finally {
    try {
      await submitWithDrafts({ ns: 'optionManagement', type: 'option' })(module)()
    } catch (e) {
      console.error('Could not submit model:', e)
    }
    model[G.CACHE] = null
    await action(module, component, event)
  }
}

export default curry(getPassword)
